import Router from 'next/router';

export const loginRedirectToConfirm = ({ user }) => {
  if (user?.intranetAccess) {
    Router.push('/intranet');
  } else {
    Router.push('/confirm-user');
  }
};
